import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";

const AuthCheck = ({ setIsLoading, layoutType }) => {
  let navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("Ananya-Enterprize-authToken");
    setTimeout(() => {
      if (layoutType === "admin" && !token) {
        navigate("/auth/sign-in");
      } else if (layoutType === "auth" && token) {
        navigate("/admin/dashboard");
      } else if (layoutType === "initialRender") {
        if (!token) {
          navigate("/auth/sign-in");
        } else {
          navigate("/admin/dashboard");
        }
      } else {
        setIsLoading(false);
      }
    }, 1000);
  }, [layoutType, navigate, setIsLoading]);
  return <Loader />;
};
export default AuthCheck;
